import { int } from "@goodgamestudios/math-utilities";
import { Poker2RankingDataEvent } from "../../event/Poker2RankingDataEvent";
import { AvatarCardVO } from "../../gamevo/AvatarCardVO";
import { HallOfFameVO } from "../../gamevo/HallOfFameVO";
import { RankingVO } from "../../gamevo/RankingVO";
import { TournamentRankingVO } from "../../gamevo/TournamentRankingVO";
import { Poker2Model } from "../Poker2Model";
import { BasicData } from "./BasicData";

export class Poker2RankingData extends BasicData {
    public rankingList: RankingVO[];
    public rankingAvatarList: AvatarCardVO[];
    public rankingTopAvatar: AvatarCardVO[];
    public tournamentRankList: TournamentRankingVO[];
    public halloffameRankList: HallOfFameVO[];

    constructor() {
        super();
    }
    public parse_RAL(paramObject: any): void {
        if (paramObject)
            this.parseRankingList(paramObject.data, paramObject.startRank);
    }
    public parse_RAA(paramObject: any): void {
        if (!paramObject)
            return;
        this.parseAvatarRankingList(paramObject.A, paramObject.startRank);
        //			seatVO.avatar = Poker2Model.avatarData.parseAvatar(avatarObject.gender, avatarObject.items);
        //TODO
    }
    public parse_RTA(paramObject: any): void {
        if (!paramObject)
            return;
        this.rankingTopAvatar = [];
        var count: number = 1;
        //Die Drei Top Spieler
        if (paramObject.a1)
            count++;
        if (paramObject.a2)
            count++;
        if (paramObject.a3)
            count++;

        for (var i: number = 1; i < count; i++) {
            var rankingAvatarVO: AvatarCardVO = new AvatarCardVO();
            rankingAvatarVO.id = int(paramObject["a" + i].id);
            rankingAvatarVO.name = paramObject["a" + i].name;
            if (!rankingAvatarVO.name)
                rankingAvatarVO.name = Poker2Model.languageData.getTextById("dialog_ranking_deletedplayer");
            rankingAvatarVO.gender = paramObject["a" + i].gender;
            rankingAvatarVO.level = int(paramObject["a" + i].level);
            rankingAvatarVO.xp = paramObject["a" + i].xp;
            rankingAvatarVO.chips = paramObject["a" + i].chips;
            rankingAvatarVO.avatar = Poker2Model.avatarData.parseAvatar(rankingAvatarVO.gender, paramObject["a" + i].allowGiveChips, paramObject["a" + i].items);
            this.rankingTopAvatar.push(rankingAvatarVO);
        }
        this.controller.dispatchEvent(new Poker2RankingDataEvent("changeRankingTopAvatarData", [count]));
    }
    public parse_RJL(paramObject: any): void {
        if (!paramObject)
            return;
        this.parseJoustRankList(paramObject.L, paramObject.startRank);
    }
    public parse_RHF(paramObject: any): void {
        if (!paramObject)
            return;
        this.parseHallOfFameList(paramObject.L);
    }
    private parseHallOfFameList(paramArray: any[]): void {
        this.halloffameRankList = [];
        if (paramArray) {
            for (var i: number = 0; i < paramArray.length; i++) {
                var element: any[] = paramArray[i];
                var hallOfFameVO: HallOfFameVO = new HallOfFameVO();
                hallOfFameVO.id = int(element.shift());
                hallOfFameVO.rang = int(element.shift());
                hallOfFameVO.name = element.shift();
                if (!hallOfFameVO.name)
                    hallOfFameVO.name = Poker2Model.languageData.getTextById("dialog_ranking_deletedplayer");
                hallOfFameVO.points = int(element.shift());

                this.halloffameRankList.push(hallOfFameVO);
            }
            this.controller.dispatchEvent(new Poker2RankingDataEvent("changeHallofFameData"));
        }
    }
    private parseJoustRankList(paramArray: any[], startRank: number): void {
        this.tournamentRankList = [];
        var startR: number = startRank;
        if (paramArray) {
            for (var i: number = 0; i < paramArray.length; i++) {
                var element: any[] = paramArray[i];
                var tournamentRankingVO: TournamentRankingVO = new TournamentRankingVO();
                tournamentRankingVO.id = int(element.shift());
                tournamentRankingVO.date = element.shift();
                tournamentRankingVO.first = element.shift();
                tournamentRankingVO.second = element.shift();
                tournamentRankingVO.third = element.shift();
                tournamentRankingVO.startRank = startR;
                this.tournamentRankList.push(tournamentRankingVO);
                startR++;
            }
            this.controller.dispatchEvent(new Poker2RankingDataEvent("changeJoustRankingData"));
        }
    }
    private parseAvatarRankingList(paramArray: any[], startRank: number): void {
        //TODO startRank vom server
        this.rankingAvatarList = [];
        var startR: number = startRank;
        if (paramArray) {
            if (paramArray != null) {
                for (let entryList of paramArray) {
                    var tableLine: any = entryList;
                    if (tableLine === undefined) continue;

                    var rankingAvatarVO: AvatarCardVO = new AvatarCardVO();
                    rankingAvatarVO.rank = startR;
                    rankingAvatarVO.id = int(tableLine.id);
                    rankingAvatarVO.name = tableLine.name;
                    if (!rankingAvatarVO.name)
                        rankingAvatarVO.name = Poker2Model.languageData.getTextById("dialog_ranking_deletedplayer");
                    rankingAvatarVO.gender = tableLine.gender;
                    rankingAvatarVO.level = int(tableLine.level);
                    rankingAvatarVO.xp = tableLine.xp;
                    rankingAvatarVO.chips = tableLine.chips;
                    rankingAvatarVO.avatar = Poker2Model.avatarData.parseAvatar(rankingAvatarVO.gender, tableLine.allowGiveChips, tableLine.items);
                    this.rankingAvatarList.push(rankingAvatarVO);
                    startR++;
                }
            }
            this.controller.dispatchEvent(new Poker2RankingDataEvent("changeRankingAvatarData"));
        }
    }

    private parseRankingList(paramString: string, startRank: number): void {
        this.rankingList = [];
        if (paramString.length > 0) {
            var startR: number = startRank;
            var paramArray: any[] = paramString.split("#");
            for (var i: number = 0; i < paramArray.length - 1; i++) {
                var element: any[] = paramArray[i].split("+");
                var rankingVO: RankingVO = new RankingVO();
                rankingVO.rank = startR;
                rankingVO.playerId = int(element.shift());
                rankingVO.name = element.shift();
                if (!rankingVO.name)
                    rankingVO.name = Poker2Model.languageData.getTextById("dialog_ranking_deletedplayer");
                rankingVO.online = int(element.shift());
                rankingVO.level = int(element.shift());
                rankingVO.xp = element.shift();
                rankingVO.chips = element.shift();
                rankingVO.acPoints = int(element.shift());
                this.rankingList.push(rankingVO);
                startR++;
            }
        }
        this.controller.dispatchEvent(new Poker2RankingDataEvent("changeRankingData"));

    }
}
